var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-tabs',{attrs:{"value":_vm.value,"items":_vm.items,"converter":_vm.$tfo},on:{"change":_vm.changeHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }